import {
  ChangeDetectionStrategy,
  Component,
  computed,
  output,
  signal,
} from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import {
  CancellationScope,
  CancelScopeDialogResult,
} from '../cancel-job.types';

@Component({
  selector: 'app-cancel-job-scope-dialog',
  standalone: true,
  imports: [MatDialogModule, MatRadioModule],
  templateUrl: './cancel-job-scope-dialog.component.html',
  styleUrl: './cancel-job-scope-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelJobScopeDialogComponent {
  readonly selectedScope = signal<CancellationScope>('ENTIRE_JOB');
  readonly continueClicked = output<CancelScopeDialogResult>();
  readonly closeClicked = output<void>();

  readonly isEntireJob = computed(
    () => this.selectedScope() === 'ENTIRE_JOB',
  );

  onScopeChange(value: string): void {
    this.selectedScope.set(value as CancellationScope);
  }

  onContinue(): void {
    this.continueClicked.emit({ scope: this.selectedScope() });
  }

  onClose(): void {
    this.closeClicked.emit();
  }
}
